const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  username: state => state.user.username,
  menus: state => state.user.menus,
  uid: state => state.user.uid,
  name: state => state.user.name,
  level: state => state.user.level,
  roles: state => state.user.roles,
  canViewRepairAmount: state => state.user.canViewRepairAmount,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js